<template>
  <el-submenu v-if="item.subItems"
      :index="item.index"
      :disabled="$isFunctionDisabled(item.funcId)"
      :class="item.class"
      popper-class="navigation-menu">
    <template slot="title">
      <i :class="item.icon" />
      <span>{{ item.title }}</span>
    </template>
    <template v-for="sub in item.subItems">
      <BaseNavigationItem v-if="$isFunctionShown(sub.funcId)"
          :key="sub.index"
          :item="sub" />
    </template>
  </el-submenu>
  <el-menu-item v-else
      :index="item.route"
      :route="item.route"
      :disabled="$isFunctionDisabled(item.funcId)"
      :class="item.class"
      @click="click(item)">
    <i :class="item.icon" />
    <span>{{ item.title }}</span>
  </el-menu-item>
</template>

<script>
export default {
  name: 'BaseNavigationItem',
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    click (item) {
      if (item.click && typeof item.click === 'function') {
        item.click(item)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/molecules/BaseNavigationItem.vue